"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOLLOWUP_MAX_TURNS = void 0;
exports.FOLLOWUP_MAX_TURNS = 30;
//# sourceMappingURL=aiSearch.js.map